<script>
  export let href = '#0';
  export let text = 'Go to main';
</script>

<a
  on:click
  class="
  px-2 rounded-5 py-1 align-baseline
  bg-stone-200 dark:bg-dark-70 dark:hover:bg-dark-60
  border dark:border-dark-60
  transition-colors duration-200
  font-lexend font-normal text-sm
  text-stone-800 dark:text-dark-30"
  {href}
>
  {text}
</a>
